import { render, staticRenderFns } from "./attach-file.vue?vue&type=template&id=3a0adf9e"
import script from "./attach-file.vue?vue&type=script&lang=js"
export * from "./attach-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports